import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LibLazyComponents} from '@components/lib-lazy-components';
import {BitmovinPlayerComponent} from '@components/video-player/bitmovin-player/bitmovin-player.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatButtonModule} from '@angular/material/button';
import {InViewportModule} from 'ng-in-viewport';
import {LibDirectivesModule} from '@utils/directives/lib-directives.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    BitmovinPlayerComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    InViewportModule,
    LibDirectivesModule,
  ]
})
export class LibBitmovinPlayerModule {
  public static components = {
    [LibLazyComponents.bitmovinPlayer]: BitmovinPlayerComponent,
  }
}
